var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 213 295",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -150.413834, -107.139008)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M324.954,243.517c17.12-9.65,26.373-28.968,23.183-48.347c-3.963-29.919-39.628-41.214-67.765-43.591v-44.978h-27.74 v44.582h-18.625v-44.582h-27.74v44.582H150.39v28.731h20.805c9.313,0,13.87,2.774,13.87,10.303V313.66 c0,10.303-5.152,13.474-10.7,13.474h-21.201v29.325h53.895v45.573h27.938v-45.573h18.625v45.573h27.146v-45.573h5.944 c57.065,0,76.087-27.938,76.087-65.981C362.343,268.047,346.789,248.748,324.954,243.517z M234.006,181.697h19.814 c13.87,0,41.214,2.378,41.214,24.966c0.951,14.742-9.729,27.661-24.372,29.523h-36.656 C234.006,236.186,234.006,181.697,234.006,181.697z M264.718,324.359v-0.198h-30.712v-59.443h35.666 c8.322,0,39.628,2.774,39.628,24.966S294.44,324.359,264.718,324.359z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/Bitcoin.b2e07c32.svg";
export { ForwardRef as ReactComponent };